import {Box, Button, CircularProgress} from "@mui/material";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import React from "react";

interface GenerateButtonProps {
  loading: boolean;
  label: string;
  onClick: () => void;
}

export default function GenerateButton({loading, label, onClick}: GenerateButtonProps) {
  return <Box sx={{m: 1, position: "relative"}}>
    <Button variant={"contained"} fullWidth
            data-testid="generate"
            startIcon={<CloudDownloadOutlinedIcon />}
            disabled={loading}
            onClick={onClick}>
      {label}
    </Button>
    {loading && (
      <CircularProgress
        size={24}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          marginTop: "-12px",
          marginLeft: "-12px"
        }}
      />
    )}
  </Box>;
}
